
import { defineComponent } from "vue";

const ALERT_ATTEMPTS_IMAGE_PATH = "peakengine/Content/Image/Security/alert_attempts.png";

export default defineComponent({
  name: "ModalOBPassword",

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    username: {
      type: String,
      default: "",
    },
  },

  emits: ["update:modelValue"],

  computed: {
    isShow: {
      get(): boolean {
        return this.modelValue;
      },
      set(value: boolean) {
        this.$emit("update:modelValue", value);
      },
    },
    alertAttemptsImageSrc(): string {
      const fileServer = (process.env.VUE_APP_PeakFileServer || "").replace(/\/?$/, "/");
      return fileServer + ALERT_ATTEMPTS_IMAGE_PATH;
    },
    descriptionHtml(): string {
      const before = "If you're unable to sign in, please click ";
      const phrase = "Forgot Password";
      const after = " to reset your password.";
      return `${before}<span class="phrase-bold">"${phrase}"</span>${after}`;
    },
    warningHtml(): string {
      const before = "Multiple failed sign-in attempts ";
      const redPart = "may temporarily suspend your account.";
      return `${before}<span class="text-danger">${redPart}</span>`;
    },
  },

  methods: {
    HandleTryAgain() {
      this.$emit("update:modelValue", false);
    },
    HandleForgotPassword() {
      this.$emit("update:modelValue", false);
      const baseUrl = (process.env.VUE_APP_BASE_URL_PEAK || "").replace(/\/?$/, "");
      window.open(`${baseUrl}/forgotPwd?a=${this.username}`, "_blank");
    },
  },
});
